import { LayoutSettings } from '@layouts/LayoutSettings'
import AdminsPage from '@pages/admin/settings/AdminsPage'
import CompaniesPage from '@pages/admin/settings/CompaniesPage'
import JobsPage from '@pages/admin/settings/JobsPage'
import { Navigate, RouteObject } from 'react-router-dom'

const settingsRoutes: RouteObject[] = [
  {
    element: <LayoutSettings />,
    children: [
      { path: 'companies', element: <CompaniesPage /> },
      { path: 'jobs', element: <JobsPage /> },
      { path: 'admins', element: <AdminsPage /> },
      { index: true, element: <Navigate to={'companies'} /> },
      { path: '*', element: <Navigate to={'companies'} /> },
    ],
  },
]

export default settingsRoutes
